import { Fragment, ReactNode } from "react";
import { StyledMenuWrapper, StyledButtonsWrapper } from "../SearchBar.styles";

export interface SearchBarButtonsProps {
    buttons?: ReactNode[];
    leftButtons?: ReactNode[];
}

/**
 * Shared buttons section for the search bar — renders left and right button groups.
 */
export function SearchBarButtons({ buttons, leftButtons }: SearchBarButtonsProps) {
    return (
        <StyledMenuWrapper hasButtons={!!buttons} className="kms-ds-searchbar-menu-wrapper">
            <StyledButtonsWrapper className="kms-ds-left-searchbar-buttons">
                {leftButtons?.map((btn, index) => <Fragment key={`left_${index}`}>{btn}</Fragment>)}
            </StyledButtonsWrapper>
            {buttons && (
                <StyledButtonsWrapper className="kms-ds-open-filters-menu">
                    {buttons?.map((btn, index) => <Fragment key={`right_${index}`}>{btn}</Fragment>)}
                </StyledButtonsWrapper>
            )}
        </StyledMenuWrapper>
    );
}
